import React, { useContext, useEffect, useRef, useState } from "react";
import { Context } from "../context/Context";
import { Link, useNavigate } from "react-router-dom";
import { DeleteScenario, UpdateScenario } from "../api/api";
import "./ScenarioList.css";
import SuccessToast from "./toasts/SuccessToast";
import ForeignScenarioModal from "./modals/ForeignScenarioModal";
import ForeignScenarioLearnCodeModal from "./modals/ForeignScenarioLearnCodeModal";
import BussScenarioModal from "./modals/BussScenarioModal";
import { MqttContext } from "../context/MQTTContext";
import ErrorToast from "./toasts/ErrorToast";
import SimpleBar from "simplebar-react";
import "simplebar-react/dist/simplebar.min.css";
import ScenarioIconModal from "./modals/ScenarioIconModal";
import EquipmentButtonIcon from "../constants/EquipmentButtonIcon";

const ScenarioList = () => {
  const navigate = useNavigate();

  const { setIsLoading } = useContext(Context);
  const { clients } = useContext(MqttContext);

  const {
    handleScenarioNameModal,
    scenarios,
    setScenarios,
    scenarioCommands,
    authUser,
    devices,
    setChangeNameOptions,
    handleChangeNameModal,
    handleScenarioIconModal,
    setEditScenarioIcon,
  } = useContext(Context);
  const [runningScenarioCommands, setRunningScenarioCommands] = useState([]);
  const [foreignScenarioModal, setForeignScenarioModal] = useState();
  const [editScenario, setEditScenario] = useState(null);
  const [editedScenarioName, setEditedScenarioName] = useState("");
  const [foreignScenarioLearnCodeModal, setForeignScenarioLearnCodeModal] =
    useState();
  const [bussScenarioModal, setBussScenarioModal] = useState();
  const [devicesCommands, setDevicesCommands] = useState({});

  const [foreignScenario, setForeignScenario] = useState(null);
  const [foreignScenarioNumber, setForeignScenarioNumber] = useState(1);
  const [bussScenario, setBussScenario] = useState(null);

  const [bussScenarioNumber, setBussScenarioNumber] = useState(1);
  const [selectedDeviceForBussScenario, setSelectedDeviceForBussScenario] =
    useState();
  const [scenarioBussUpdate, setScenarioBussUpdate] = useState(false);

  const client = useRef();
  const scenarioBussClient = useRef();
  const activeListeners = useRef({});

  useEffect(() => {
    const cleanupListeners = () => {
      Object.keys(activeListeners.current).forEach((deviceId) => {
        const listenerInfo = activeListeners.current[deviceId];
        if (listenerInfo && listenerInfo.client) {
          listenerInfo.client.off("message", listenerInfo.listener);
        }
      });
      activeListeners.current = {};
    };
    return cleanupListeners;
  }, []);

  useEffect(() => {
    if (runningScenarioCommands.length) {
      processWithDelay(runningScenarioCommands);
    }
  }, [runningScenarioCommands]);

  const handleForeignScenarioModal = (scenario) => {
    setForeignScenario(scenario);
    const modal = new window.bootstrap.Modal(foreignScenarioModal.current);
    modal.show();
  };

  const handleForeignScenarioLearnCodeModal = () => {
    const modal = new window.bootstrap.Modal(
      foreignScenarioLearnCodeModal.current,
    );
    modal.show();
  };

  const handleRemoveScenario = (scenarioId) => {
    setIsLoading(true);
    DeleteScenario({
      scenario_id: scenarioId,
    }).then(({ data }) => {
      let updatedScenarios = scenarios.filter(
        (scenario) => scenario.id != scenarioId,
      );
      setScenarios(updatedScenarios);
      setIsLoading(false);
    });
  };

  const handleRunScenario = (scenario) => {
    let commands = scenarioCommands.filter(
      (command) => command.scenario_id == scenario.id,
    );
    if (commands.length < 1) {
      return ErrorToast("دستوری برای این سناریو تعریف نشده است");
    }
    if (scenario.type == 0) {
      setRunningScenarioCommands(commands);
      SuccessToast("سناریو اجرا شد");
    } else if (scenario.type == 1) {
      if (!commands.length) return;
      let total_time = 0;

      for (let i = 0; i < commands.length; i++) {
        total_time += commands[i].time;
      }

      const orderedDeviceIds = [];
      const groupedByDeviceId = commands.reduce((acc, item) => {
        const { device_id } = item;

        if (!acc[device_id]) {
          acc[device_id] = [];
          orderedDeviceIds.push(device_id);
        }

        acc[device_id].push(item);
        return acc;
      }, {});

      let devices_count = {};
      orderedDeviceIds.forEach((deviceId, index) => {
        if (index === 0) {
          devices_count[deviceId] = groupedByDeviceId[deviceId].length;
        } else {
          devices_count[deviceId] = groupedByDeviceId[deviceId].length + 1;
        }
      });

      // مقدار devicesCommands را خالی می‌کنیم
      let devicesCommands = {}; // متغیر جدید برای ذخیره‌سازی

      let calc_time = 0;
      commands.forEach((command) => {
        let device = devices.find((d) => d.id == command.device_id);
        if (!device) {
          return;
        }
        if (!devicesCommands.hasOwnProperty(command.device_id)) {
          devicesCommands[command.device_id] = [
            7,
            0,
            devices_count[command.device_id],
          ];
          if (command.device_id != commands[0].device_id) {
            if (
              device.type == 1 ||
              device.type == 2 ||
              device.type == 7 ||
              device.type == 8 ||
              device.type == 10 ||
              device.type == 11 ||
              device.type == 12 ||
              device.type == 13 ||
              device.type == 14 ||
              device.type == 15
            ) {
              devicesCommands[command.device_id] = [
                ...devicesCommands[command.device_id],
                0,
                0,
                (calc_time & 0xff00) >> 8,
                calc_time & 0xff,
              ];
            }
            if (device.type == 5) {
              devicesCommands[command.device_id] = [
                ...devicesCommands[command.device_id],
                0,
                0,
                0,
                0,
                (calc_time & 0xff00) >> 8,
                calc_time & 0xff,
              ];
            }
            if (device.type == 4 || device.type == 9) {
              devicesCommands[command.device_id] = [
                ...devicesCommands[command.device_id],
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                (calc_time & 0xff00) >> 8,
                calc_time & 0xff,
              ];
            }
            if (device.type == 3) {
              devicesCommands[command.device_id] = [
                ...devicesCommands[command.device_id],
                0,
                (calc_time & 0xff00) >> 8,
                calc_time & 0xff,
              ];
            }
          }
        }

        let time = 0;
        for (const cmd of commands) {
          if (cmd.id >= command.id) {
            if (cmd.device_id == command.device_id && cmd.id != command.id) {
              break; // Exit the loop when the device_id matches
            }
            time += Number(cmd.time); // Accumulate time
          }
        }
        // جمع‌آوری داده‌ها
        devicesCommands[command.device_id] = [
          ...devicesCommands[command.device_id],
          ...(command.data1 != null ? [Number(command.data1)] : []),
          ...(command.data2 != null ? [Number(command.data2)] : []),
          ...(command.data3 != null ? [Number(command.data3)] : []),
          ...(command.data4 != null ? [Number(command.data4)] : []),
          ...(command.data5 != null ? [Number(command.data5)] : []),
          ...(command.data6 != null ? [Number(command.data6)] : []),
          ...(command.data7 != null ? [Number(command.data7)] : []),
          ...(command.data8 != null ? [Number(command.data8)] : []),
          ...(command.data9 != null ? [Number(command.data9)] : []),
          ...(command.data10 != null ? [Number(command.data10)] : []),
          ...(command.data11 != null ? [Number(command.data11)] : []),
          ((Number(time) / 500) & 0xff00) >> 8,
          (Number(time) / 500) & 0xff,
          ...(groupedByDeviceId[command.device_id][
            groupedByDeviceId[command.device_id].length - 1
          ].id == command.id
            ? [scenario.repeat && scenario.repeat != 0 ? scenario.repeat : 1]
            : []),
        ];

        calc_time += Number(command.time) / 500;
      });

      // در نهایت، setDevicesCommands را با مقدار جدید فراخوانی می‌کنیم
      setDevicesCommands(devicesCommands);

      for (const device_id in devicesCommands) {
        let device = devices.find((d) => d.id == device_id);
        if (!device) {
          return;
        }
        if (device.is_bus == 1 && clients[device?.bridge_device?.id]) {
          if (!clients[device.bridge_device.id]) return;

          const messageListener = (topic, message, packet) => {
            const endOfTwoCharToken =
              String.fromCharCode(message[0]) + String.fromCharCode(message[1]);
            const deviceSerial =
              String.fromCharCode(message[3]) +
              String.fromCharCode(message[4]) +
              String.fromCharCode(message[5]) +
              String.fromCharCode(message[6]) +
              String.fromCharCode(message[7]) +
              String.fromCharCode(message[8]);
            if (
              device.bridge_device.internet_token.slice(-2) ==
                endOfTwoCharToken &&
              device.serial == deviceSerial &&
              message[10] == 8 &&
              message[2] == 14
            ) {
              if (message[11] == 0) {
                SuccessToast(
                  `دستگاه "${device.name ? device.name : device.serial}" سناریو را دریافت کرد`,
                );
              }
              clients[device.bridge_device.id].off("message", messageListener);
              if (activeListeners.current[device.id]) {
                delete activeListeners.current[device.id];
              }
            }
          };
          if (activeListeners.current[device.id]) {
            clients[device.bridge_device.id].off(
              "message",
              activeListeners.current[device.id].listener,
            );
          }
          activeListeners.current[device.id] = {
            client: clients[device.bridge_device.id],
            listener: messageListener,
          };
          clients[device.bridge_device.id].on("message", messageListener);

          let buffer = new ArrayBuffer(devicesCommands[device_id].length + 8);
          let asciiCode = new Uint8Array(buffer);
          asciiCode[0] = 14;
          asciiCode[1] = `${device.serial[0]}`.charCodeAt(0);
          asciiCode[2] = `${device.serial[1]}`.charCodeAt(0);
          asciiCode[3] = `${device.serial[2]}`.charCodeAt(0);
          asciiCode[4] = `${device.serial[3]}`.charCodeAt(0);
          asciiCode[5] = `${device.serial[4]}`.charCodeAt(0);
          asciiCode[6] = `${device.serial[5]}`.charCodeAt(0);
          asciiCode[7] = device.type + 50;
          for (let i = 0; i <= devicesCommands[device_id].length; i++) {
            asciiCode[i + 8] = devicesCommands[device_id][i];
          }
          let message = device.bridge_device.internet_token;
          let combinedMessage = concatenateStringAndBuffer(message, asciiCode);
          clients[device.bridge_device.id].publish(
            device.bridge_device.serial + "/sys",
            combinedMessage,
          );
        } else {
          if (!clients[device.id]) return;

          const messageListener = (topic, message, packet) => {
            const endOfTwoCharToken =
              String.fromCharCode(message[0]) + String.fromCharCode(message[1]);
            if (
              device.internet_token.slice(-2) == endOfTwoCharToken &&
              message[2] == 8
            ) {
              if (message[3] == 0) {
                SuccessToast(
                  `دستگاه "${device.name ? device.name : device.serial}" سناریو را دریافت کرد`,
                );
              }
              clients[device.id].off("message", messageListener);
              if (activeListeners.current[device.id]) {
                delete activeListeners.current[device.id];
              }
            }
          };
          if (activeListeners.current[device.id]) {
            clients[device.id].off(
              "message",
              activeListeners.current[device.id].listener,
            );
          }

          activeListeners.current[device.id] = {
            client: clients[device.id],
            listener: messageListener,
          };
          clients[device.id].on("message", messageListener);

          let buffer = new ArrayBuffer(devicesCommands[device_id].length);
          let asciiCode = new Uint8Array(buffer);
          for (let i = 0; i <= devicesCommands[device_id].length; i++) {
            asciiCode[i] = devicesCommands[device_id][i];
          }
          let message = device.internet_token;
          let combinedMessage = concatenateStringAndBuffer(message, asciiCode);
          clients[device.id].publish(device.serial + "/sys", combinedMessage);
        }
      }
    }
  };

  const processWithDelay = async (array) => {
    let client;
    for (const command of array) {
      let device = devices.find((d) => d.id == command.device_id);
      if (!device) {
        return;
      }
      if (device.is_bus == 1 && clients[device?.bridge_device?.id]) {
        const data = makeData(command);
        let buffer = new ArrayBuffer(data.lenght + 9);
        let asciiCode = new Uint8Array(buffer);
        asciiCode[0] = 14;
        asciiCode[1] = `${device.serial[0]}`.charCodeAt(0);
        asciiCode[2] = `${device.serial[1]}`.charCodeAt(0);
        asciiCode[3] = `${device.serial[2]}`.charCodeAt(0);
        asciiCode[4] = `${device.serial[3]}`.charCodeAt(0);
        asciiCode[5] = `${device.serial[4]}`.charCodeAt(0);
        asciiCode[6] = `${device.serial[5]}`.charCodeAt(0);
        asciiCode[7] = device.type + 50;
        asciiCode[8] = 1;
        for (let i = 0; i <= data.lenght; i++) {
          asciiCode[i + 9] = data.data[i];
        }
        let message = device.bridge_device.internet_token;
        let combinedMessage = concatenateStringAndBuffer(message, asciiCode);
        clients[device.bridge_device.id].publish(
          device.bridge_device.serial + "/sys",
          combinedMessage,
        );

        // client.end();

        await new Promise((resolve) => setTimeout(resolve, command.time));
      } else {
        const data = makeData(command);
        let buffer = new ArrayBuffer(data.lenght + 1);
        let asciiCode = new Uint8Array(buffer);
        asciiCode[0] = 1;
        for (let i = 1; i <= data.lenght; i++) {
          asciiCode[i] = data.data[i - 1];
        }
        let message = device.internet_token;
        let combinedMessage = concatenateStringAndBuffer(message, asciiCode);
        clients[device.id].publish(device.serial + "/sys", combinedMessage);

        // client.end();

        await new Promise((resolve) => setTimeout(resolve, command.time));
      }
    }
    client.end();
  };

  const concatenateStringAndBuffer = (str, buffer) => {
    let encoder = new TextEncoder();
    let encodedString = encoder.encode(str);

    let newBuffer = new Uint8Array(encodedString.length + buffer.byteLength);

    newBuffer.set(encodedString, 0);

    newBuffer.set(new Uint8Array(buffer), encodedString.length);

    return newBuffer;
  };

  const makeData = (item) => {
    let lenght = 0;
    let data = [];
    if (item.data1) {
      lenght += 1;
      data.push(item.data1);
    }
    if (item.data2) {
      lenght += 1;
      data.push(item.data2);
    }
    if (item.data3) {
      lenght += 1;
      data.push(item.data3);
    }
    if (item.data4) {
      lenght += 1;
      data.push(item.data4);
    }
    if (item.data5) {
      lenght += 1;
      data.push(item.data5);
    }
    if (item.data6) {
      lenght += 1;
      data.push(item.data6);
    }
    if (item.data7) {
      lenght += 1;
      data.push(item.data7);
    }
    if (item.data8) {
      lenght += 1;
      data.push(item.data8);
    }
    if (item.data9) {
      lenght += 1;
      data.push(item.data9);
    }
    if (item.data10) {
      lenght += 1;
      data.push(item.data10);
    }
    if (item.data11) {
      lenght += 1;
      data.push(item.data11);
    }

    return {
      lenght,
      data,
    };
  };

  const checkForeignScenario = (commands) => {
    if (!commands.length) return false;

    const firstDeviceId = commands[0].device_id;
    return commands.every((item) => item.device_id === firstDeviceId);
  };

  const calculate_time_code = (time) => {
    if (time >= 0 && time <= 20000) {
      return time / 500;
    } else if (time >= 21000 && time <= 59000) {
      return time / 1000 + 20;
    } else if (time == 60000) {
      return 80;
    } else if (time == 120000) {
      return 81;
    } else if (time == 180000) {
      return 82;
    } else if (time == 240000) {
      return 83;
    } else if (time == 300000) {
      return 84;
    } else if (time == 600000) {
      return 89;
    } else if (time == 900000) {
      return 94;
    } else if (time == 1200000) {
      return 99;
    } else if (time == 1800000) {
      return 109;
    } else if (time == 2400000) {
      return 119;
    } else if (time == 3000000) {
      return 129;
    } else if (time == 3600000) {
      return 139;
    }
  };

  const handleAssignForeignScenario = (scenario, type = "", num = 0) => {
    let commands = scenarioCommands.filter(
      (command) => command.scenario_id == foreignScenario.id,
    );
    if (!commands.length) return;

    let device = devices.find((d) => d.id == commands[0].device_id);
    if (!device) return;

    let data = [7, Number(foreignScenarioNumber), commands.length];

    let i = 1;
    commands.forEach((cmd) => {
      for (let index = 1; index <= 11; index++) {
        const value = cmd[`data${index}`];
        if (value !== null) {
          data.push(value);
        }
      }

      if (i == commands.length && foreignScenario.type == 0) {
        data.push(0);
      } else {
        data.push(calculate_time_code(cmd.time));
      }

      i++;
    });

    if (foreignScenario.type == 1) {
      data.push(foreignScenario.repeat ?? 1);
    }

    // بررسی نوع دستگاه (باس یا بدون باس)
    if (
      device.is_bus == 1 &&
      device.bridge_device &&
      clients[device?.bridge_device?.id]
    ) {
      // دستگاه باس - ارسال از طریق bridge_device
      const bridgeClient = clients[device.bridge_device.id];

      // حذف listener قبلی اگر وجود داشته باشد
      if (bridgeClient._assignForeignScenarioListener) {
        bridgeClient.off(
          "message",
          bridgeClient._assignForeignScenarioListener,
        );
        bridgeClient._assignForeignScenarioListener = null;
      }

      const messageListener = (topic, message, packet) => {
        if (!message || message.length < 3) return;

        const endOfTwoCharToken =
          String.fromCharCode(message[0]) + String.fromCharCode(message[1]);

        const deviceSerial =
          String.fromCharCode(message[3]) +
          String.fromCharCode(message[4]) +
          String.fromCharCode(message[5]) +
          String.fromCharCode(message[6]) +
          String.fromCharCode(message[7]) +
          String.fromCharCode(message[8]);

        if (
          device.bridge_device.internet_token.slice(-2) === endOfTwoCharToken &&
          device.serial === deviceSerial &&
          message[2] == 14 &&
          message[10] == 8
        ) {
          SuccessToast(`به ${type} ${num} اختصاص یافت`);
          bridgeClient.off("message", messageListener);
          if (activeListeners.current[device.bridge_device.id]) {
            delete activeListeners.current[device.bridge_device.id];
          }
          bridgeClient._assignForeignScenarioListener = null;
        }
      };

      if (activeListeners.current[device.bridge_device.id]) {
        bridgeClient.off(
          "message",
          activeListeners.current[device.bridge_device.id].listener,
        );
      }

      activeListeners.current[device.bridge_device.id] = {
        client: bridgeClient,
        listener: messageListener,
      };

      bridgeClient._assignForeignScenarioListener = messageListener;
      bridgeClient.on("message", messageListener);

      // ساخت بافر با فرمت مخصوص دستگاه‌های باس
      let buffer = new ArrayBuffer(8 + data.length);
      let asciiCode = new Uint8Array(buffer);

      // 10 بایت اول برای هدر مخصوص دستگاه باس
      asciiCode[0] = 14; // کد دستور
      asciiCode[1] = `${device.serial[0]}`.charCodeAt(0);
      asciiCode[2] = `${device.serial[1]}`.charCodeAt(0);
      asciiCode[3] = `${device.serial[2]}`.charCodeAt(0);
      asciiCode[4] = `${device.serial[3]}`.charCodeAt(0);
      asciiCode[5] = `${device.serial[4]}`.charCodeAt(0);
      asciiCode[6] = `${device.serial[5]}`.charCodeAt(0);
      asciiCode[7] = device.type + 50; // نوع دستگاه + 50

      // کپی کردن داده‌های اصلی از ایندکس 10 به بعد
      for (let j = 0; j < data.length; j++) {
        asciiCode[8 + j] = data[j];
      }

      const message = device.bridge_device.internet_token;

      const combinedMessage = concatenateStringAndBuffer(message, asciiCode);
      console.log('message is', combinedMessage);

      bridgeClient.publish(
        device.bridge_device.serial + "/sys",
        combinedMessage,
      );
    } else if (device.is_bus == 0 && clients[device.id]) {
      // دستگاه بدون باس - کد قبلی
      const client = clients[device.id];

      // remove previous listener if exists
      if (client._assignForeignScenarioListener) {
        client.off("message", client._assignForeignScenarioListener);
        client._assignForeignScenarioListener = null;
      }

      const messageListener = (topic, message, packet) => {
        if (!message || message.length < 3) return;

        const endOfTwoCharToken =
          String.fromCharCode(message[0]) + String.fromCharCode(message[1]);

        if (
          device.internet_token.slice(-2) === endOfTwoCharToken &&
          message[2] == 8
        ) {
          SuccessToast(`به ${type} ${num} اختصاص یافت`);
          client.off("message", messageListener);
          if (activeListeners.current[device.id]) {
            delete activeListeners.current[device.id];
          }
          client._assignForeignScenarioListener = null;
        }
      };

      if (activeListeners.current[device.id]) {
        client.off("message", activeListeners.current[device.id].listener);
      }

      activeListeners.current[device.id] = {
        client: client,
        listener: messageListener,
      };

      client._assignForeignScenarioListener = messageListener;
      client.on("message", messageListener);

      const buffer = new ArrayBuffer(data.length);
      const asciiCode = new Uint8Array(buffer);

      for (let i = 0; i < data.length; i++) {
        asciiCode[i] = data[i];
      }

      const message = device.internet_token;
      const combinedMessage = concatenateStringAndBuffer(message, asciiCode);

      clients[device.id].publish(device.serial + "/sys", combinedMessage);
    }
  };

  const handleShowBussScenarioModal = (scenario) => {
    setBussScenario(scenario);
    const modal = new window.bootstrap.Modal(bussScenarioModal.current);
    modal.show();
  };

  const checkBussScenario = (scenario) => {
    let state = false;
    let commands = scenarioCommands.filter(
      (command) => command.scenario_id == scenario.id,
    );
    if (commands.length && scenario.type == 1) {
      commands.map((cmd) => {
        let device = devices.find((d) => d.id == cmd.device_id);
        if (!device) {
          return;
        }
        if (!device) return false;
        if (device.fw_version >= 15) state = true;
      });
    }

    return state;
  };

  const handleChangeNameScenario = (scenario) => {
    const onSubmitFunc = ({ scenario, name }) => {
      UpdateScenario({
        scenario_id: scenario.id,
        type: scenario.type,
        name: name,
      }).then((res) => {
        if (res.status == 200) {
          setEditedScenarioName("");
          setEditScenario(null);
          SuccessToast("با موفقیت ثبت شد");

          const index = scenarios.findIndex((item) => item.id === scenario.id);

          if (index !== -1) {
            const updatedScenarios = [...scenarios];
            updatedScenarios[index] = {
              ...updatedScenarios[index],
              name: name,
            };

            setScenarios(updatedScenarios);
          }
        }
      });
    };
    const newOptions = {
      name: scenario.name,
      onSubmit: (newName) => {
        onSubmitFunc({ scenario, name: newName });
      },
    };
    setChangeNameOptions(newOptions);
    handleChangeNameModal();
  };

  // Function to render scenarios
  const renderScenarios = () => {
    if (scenarios.length) {
      return scenarios.map((scenario, index) => {
        let commands = scenarioCommands.filter(
          (command) => command.scenario_id == scenario.id,
        );
        let foreignScenario = checkForeignScenario(commands);
        let iconPath = "/assets/img/app-icons/dN.png";
        if (scenario.icon) {
          let scenarioIcon = EquipmentButtonIcon.find(
            (icon) => icon.id == scenario.icon,
          );
          iconPath = scenarioIcon.path;
        }
        return (
          <div
            key={index}
            className="scenario position-relative"
            onClick={() => handleRunScenario(scenario)}
          >
            {authUser.is_admin ? (
              <div
                className="btn-group"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                }}
              >
                <button
                  type="button"
                  className="btn btn-icon rounded-pill dropdown-toggle hide-arrow"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <i className="bx bx-dots-vertical-rounded"></i>
                </button>
                <ul className="dropdown-menu">
                  {foreignScenario && (
                    <li>
                      <Link
                        className="dropdown-item"
                        onClick={() => handleForeignScenarioModal(scenario)}
                      >
                        اختصاص به سناریو خارجی
                      </Link>
                    </li>
                  )}
                  {checkBussScenario(scenario) ? (
                    <li>
                      <Link
                        className="dropdown-item"
                        onClick={() => handleShowBussScenarioModal(scenario)}
                      >
                        اختصاص به سناریو تحت باس
                      </Link>
                    </li>
                  ) : null}

                  <li>
                    <Link
                      className="dropdown-item"
                      to={"/planning/scenario/" + scenario.id}
                    >
                      ویرایش
                    </Link>
                  </li>
                  <li
                    onClick={() => {
                      handleScenarioIconModal(true);
                      setEditScenarioIcon(scenario);
                    }}
                  >
                    <Link
                      className="dropdown-item"
                      onClick={(e) => e.preventDefault()}
                    >
                      تغییر آیکون
                    </Link>
                  </li>
                  <li>
                    <Link
                      onClick={() => {
                        handleChangeNameScenario(scenario);
                      }}
                      className="dropdown-item"
                    >
                      تغییر نام
                    </Link>
                  </li>
                  <li>
                    <Link
                      className="dropdown-item"
                      // to={"/planning/scenario/" + scenario.id}
                      onClick={() => handleRemoveScenario(scenario.id)}
                    >
                      حذف
                    </Link>
                  </li>
                </ul>
              </div>
            ) : null}

            {scenario.type == 1 ? (
              <div
                className="scen-type position-absolute"
                style={{ left: "0" }}
              >
                <img
                  src="/assets/img/app-icons/XQ.png"
                  style={{ width: "30px" }}
                  alt=""
                />
              </div>
            ) : (
              <div
                className="scen-type position-absolute"
                style={{ left: "0" }}
              >
                <img
                  src="/assets/img/app-icons/RU.png"
                  style={{ width: "30px" }}
                  alt=""
                />
              </div>
            )}

            <div className="icon-part">
              <img src={iconPath} alt="" />
            </div>
            <div className="info-part">
              <p
                className={
                  editScenario == scenario.id
                    ? "d-none"
                    : "text-center p-0 m-0 d-block"
                }
              >
                {scenario.name}
              </p>
              <div
                className={
                  editScenario == scenario.id ? "mt-2 d-block" : "d-none"
                }
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                }}
              >
                <div>
                  <input
                    id="smallInput"
                    className="form-control form-control-sm text-center"
                    name="room_name"
                    type="text"
                    placeholder="نام کلید را وارد کنید"
                    value={editedScenarioName}
                    onChange={(e) => setEditedScenarioName(e.target.value)}
                  />
                </div>
                <div className="mt-1">
                  <button
                    type="button"
                    className="btn btn-xs btn-success-app submit-add-room me-2"
                    onClick={() => handleChangeNameScenario(scenario)}
                  >
                    ثبت
                  </button>
                  <button
                    type="button"
                    className="btn btn-xs btn-success-app"
                    onClick={(e) => setEditScenario(null)}
                  >
                    انصراف
                  </button>
                </div>
              </div>
            </div>
          </div>
        );
      });
    }
  };

  return (
    <>
      <div
        className="card h-100"
        style={{ backgroundColor: "#fff0", boxShadow: "none" }}
      >
        <div className="card-header d-flex align-items-center justify-content-between border-bottom mb-3 p-0 pt-2">
          <h5>سناریوها</h5>
          {authUser.is_admin ? (
            <button
              type="button"
              className="btn btn-icon btn-success-app"
              onClick={() => handleScenarioNameModal(true)}
            >
              <i className="bx bx-plus"></i>
            </button>
          ) : null}
        </div>
        <div className="card-body scrollbar">
          {/* <SimpleBar style={{ maxHeight: "100%", padding: "1.5rem" }}> */}
          <div className="d-flex flex-wrap justify-content-between justify-content-sm-start">
            {renderScenarios()}
          </div>
          {/* </SimpleBar> */}
        </div>
      </div>
      <ForeignScenarioModal
        setForeignScenarioModal={setForeignScenarioModal}
        foreignScenario={foreignScenario}
        handleForeignScenarioLearnCodeModal={
          handleForeignScenarioLearnCodeModal
        }
        foreignScenarioNumber={foreignScenarioNumber}
        setForeignScenarioNumber={setForeignScenarioNumber}
        handleAssignForeignScenario={handleAssignForeignScenario}
      />
      <ForeignScenarioLearnCodeModal
        setForeignScenarioLearnCodeModal={setForeignScenarioLearnCodeModal}
        handleAssignForeignScenario={handleAssignForeignScenario}
        foreignScenario={foreignScenario}
      />
      <BussScenarioModal
        setBussScenarioModal={setBussScenarioModal}
        inputNum={bussScenarioNumber}
        setInputNum={setBussScenarioNumber}
        selectedDevice={selectedDeviceForBussScenario}
        setSelectedDevice={setSelectedDeviceForBussScenario}
        setUpdate={setScenarioBussUpdate}
        update={scenarioBussUpdate}
        scenario={bussScenario}
      />
      <ScenarioIconModal />
    </>
  );
};

export default ScenarioList;
